import type { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function TrendingUpIcon({ size = 24, className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path
        d="M22.5004 12.0004V18.0004C22.5004 18.1993 22.4214 18.3901 22.2807 18.5307C22.1401 18.671 21.9493 18.7504 21.7504 18.7504H15.7504C15.5515 18.7504 15.3607 18.6714 15.2201 18.5307C15.0794 18.3901 15.0004 18.1993 15.0004 18.0004C15.0004 17.8015 15.0794 17.6107 15.2201 17.4701C15.3607 17.3294 15.5515 17.2504 15.7504 17.2504H19.9401L12.7504 10.0607L9.53104 13.281C9.46139 13.3508 9.37867 13.4061 9.28762 13.4438C9.19657 13.4816 9.09898 13.501 9.00042 13.501C8.90186 13.501 8.80426 13.4816 8.71321 13.4438C8.62216 13.4061 8.53945 13.3508 8.46979 13.281L1.71979 6.53104C1.57906 6.39031 1.5 6.19944 1.5 6.00042C1.5 5.80139 1.57906 5.61052 1.71979 5.46979C1.86052 5.32906 2.05139 5.25 2.25042 5.25C2.44944 5.25 2.64031 5.32906 2.78104 5.46979L9.00042 11.6901L12.2198 8.46979C12.2894 8.40006 12.3722 8.34474 12.4632 8.307C12.5543 8.26925 12.6519 8.24983 12.7504 8.24983C12.849 8.24983 12.9466 8.26925 13.0376 8.307C13.1287 8.34474 13.2114 8.40006 13.281 8.46979L21.0004 16.1901V12.0004C21.0004 11.8015 21.0794 11.6107 21.2201 11.4701C21.3607 11.3294 21.5515 11.2504 21.7504 11.2504C21.9493 11.2504 22.1401 11.3294 22.2807 11.4701C22.4214 11.6107 22.5004 11.8015 22.5004 12.0004Z"
        fill="currentColor"
      />
    </svg>
  );
}
